export const STATUS = [{
  name: 'tba',
  label: 'TBA',
  value: '1'
}, {
  name: 'compliant',
  label: 'Compliant',
  value: '2'
}, {
  name: 'unonompliant',
  label: 'Non Compliant',
  value: '3'
}]
export const PHOTOS = [{
  name: 'generalPhoto',
  label: 'General Photo',
  value: '1'
}, {
  name: 'nonCompliant',
  label: 'Non Compliant Photo',
  value: '2'
}]



// WEBPACK FOOTER //
// ./src/ESMItems.js